import { REGIONS_QUERY, COUNTRIES_QUERY } from './operations';

export const filterTypes = [
  {
    name: 'regions',
    key: 'regions',
    label: 'REGION',
    query: REGIONS_QUERY,
    menuItems: null,
    optionKey: 'displayName',
    runQueryAfterOnChange: false,
    queryVariable: null,
    multiple: true,
  },
  {
    name: 'countries',
    key: 'countries',
    label: 'COUNTRY / AREA',
    query: COUNTRIES_QUERY,
    menuItems: null,
    optionKey: 'displayName',
    runQueryAfterOnChange: false,
    queryVariable: null,
    multiple: true,
    propVariables: ({ countries, regions }) => ({
      filters: {
        countries,
        regions,
      },
    }),
  },
];
